module.exports = __webpack_public_path__ + "img/header.a5757776.jpg";